import React from 'react';
import ScreenDistanceSketch from '../../../img/screen_distance_sketch.png';
import { VidebisButton } from '../../shared/components/videbis-button/videbis-button';
import { ConfigTitle } from './config-title';
import { GlobalLogic } from '../../shared/logic/global-logic';
import '../styles/distance-from-screen.scss';

interface Props {
    onPress: () => void;
    onBack: () => void;
}

export class DistanceFromScreen extends React.PureComponent<Props> {
    private _globalLogic = GlobalLogic.getInstance();

    render(): any {
        return (
            <section className={'limit-width'}>
                <ConfigTitle title={'Kalibrierung'} subtitle={'4. Schritt: Bildschirmabstand einstellen'} />
                <div className={'user-data__arms'}>
                    <div className={'user-data__arms__img'}>
                        <img
                            src={ScreenDistanceSketch}
                            alt={'Skizzenhafte Instruktion zur optimalen Entfernung zum Bildschirm'}
                        />
                    </div>
                    <p className={'user-data__text standard-text'}>
                        Strecken Sie nun Ihren Arm gerade
                        zum Bildschirm aus und versuchen Sie,
                        diesen Abstand beizubehalten.
                    </p>
                    <p className={'standard-text'}>
                        Wir gehen bei Ihren Maßen von einer Distanz von {this._globalLogic.distance.toFixed(0)} cm
                        zwischen Ihnen und dem Bildschirm aus.
                    </p>
                </div>
                <div className={'user-data__buttons'}>
                    <VidebisButton onPress={this.props.onBack} text={'Zurück'} bgColor={'#ffffff'} txtColor={'#0c23fb'} />
                    <VidebisButton onPress={this.props.onPress} text={'Tests starten!'} width={25}/>
                </div>
            </section>
        );
    }
}
